import React, { Component } from 'react'
import L from 'leaflet';

// ESTO ES PARA EL ICONO POR DEFAULT


export class utilLeaflet{
  latDefault = -12.069538270159754;
  lngDefault = -77.047119140625;
  zoomDefault = 13;

  constructor(){
    this.map = ""
    this.mapDiv = ""
    this.marcadores = []
    this.polilineas = []
    this.poligonos = []
  }

  inicializarMapa({mapDiv,zoom = this.zoomDefault, lat = this.latDefault, lng = this.lngDefault}){
    if(this.map)   return

    this.mapDiv = mapDiv;
    this.map = L.map(this.mapDiv).setView([lat, lng], zoom);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map);
  }

  crearMarcador({
    lat, lng, 
    centrar = false, 
    icono = "", 
    contenidoPopUp = ""
  }){
    let marcador = "";
    if(icono){
      const iconoCustomizado = L.icon({
        iconUrl: icono, // La imagen importada o ruta relativa
        iconSize: [20, 20], // Tamaño del ícono
        iconAnchor: [10, 10], // Punto de anclaje (ajusta según el diseño de tu ícono)
        popupAnchor: [0, -10], // Punto relativo del popup al ícono
      });
      const objIcon = {
        icon: iconoCustomizado
      }
      marcador = L.marker([lat, lng], objIcon).addTo(this.map); // MARCADOR CON ICONO CUSTOMIZADO
    }else {
      delete L.Icon.Default.prototype._getIconUrl;
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
      });
      marcador = L.marker([lat, lng]).addTo(this.map);  // MARCADOR CON ICONO DEFAULT
    }
    
    this.marcadores.push(marcador);
    centrar && this.map.panTo(marcador.getLatLng());
    
    if(contenidoPopUp){
      marcador.bindPopup(contenidoPopUp)
    }

    return marcador
  }

  centrarMarcador(marcador){
    this.map.panTo(marcador.getLatLng())
  }

  abrirPopUpMarcador(marcador, funcionCierre = () => {}){
    marcador.openPopup()
    this.mapDiv.querySelector('.leaflet-popup-close-button').onclick = () => {
      funcionCierre()
    }
  }

  eliminarMarcador(marcador){
    marcador.remove();
    this.marcadores.filter(elem => elem != marcador);
  }

  eliminarTodosLosMarcadores(){
    this.marcadores.forEach(marcador => marcador.remove())
    this.marcadores = []
  }

  crearPolilinea({
    arrPuntos,
    color = "red",
    ancho = 4,
    opacidad = 0.7,
    centrar = false
  }){
    const polilinea = L.polyline(arrPuntos, {
      color: color,
      weight: ancho,
      opacity: opacidad
    }).addTo(this.map);
    this.polilineas.push(polilinea)
    if(centrar){
      this.map.fitBounds(polilinea.getBounds());
    }

    return polilinea
  }

  eliminarPolilinea(polilinea){
    polilinea.remove()
    this.polilineas.filter(elem => elem != polilinea)
  }

  eliminarTodasLasPolilineas(){
    this.polilineas.forEach(polilinea => polilinea.remove())
    this.polilineas = []
  }
}